export var TrackableEvents;
(function (TrackableEvents) {
    TrackableEvents["ViewedSignUp"] = "Viewed-Signup";
    TrackableEvents["ViewSignIn"] = "View Sign In";
    TrackableEvents["SaveClass"] = "Save Class";
    TrackableEvents["CreatedList"] = "Created List";
    TrackableEvents["ClickedClassCard"] = "Clicked-ClassCard";
    TrackableEvents["ClickedLessonCard"] = "Clicked-LessonCard";
    TrackableEvents["ClickedTeacherName"] = "Clicked-TeacherName";
    TrackableEvents["SelectedPaymentMethod"] = "Select Payment Method";
    TrackableEvents["RemovedClassFromAllSaved"] = "Removed Class From All Saved";
    TrackableEvents["Clicked-SearchResult-Class"] = "Clicked-SearchResult-Class";
    TrackableEvents["Clicked-SearchResult-Teacher"] = "Clicked-SearchResult-Teacher";
    TrackableEvents["Clicked-SearchResult-AddToList"] = "Clicked-SearchResult-AddToList";
    TrackableEvents["Search"] = "search";
    TrackableEvents["Clicked-Browse-Pagination"] = "Clicked-Browse-Pagination";
    TrackableEvents["Close-Premium-Classes-Modal"] = "Close-Premium-Classes-Modal";
    TrackableEvents["Clicked-Class-End-Class-Card"] = "Clicked-Class-End-Class-Card";
    TrackableEvents["AnnualPlanSelected"] = "Checkout Annual Plan Selected";
    TrackableEvents["MonthlyPlanSelected"] = "Checkout Monthly Plan Selected";
    TrackableEvents["InitiateCheckout"] = "Initiate Checkout";
    TrackableEvents["InvalidCCError"] = "Checkout Invalid Credit Card Input";
    TrackableEvents["CouponApplied"] = "Checkout Discount Code Button Clicked";
    TrackableEvents["StartGooglePayFlow"] = "Start Google Pay Flow";
    TrackableEvents["StartApplePayFlow"] = "Start Apple Pay Flow";
    TrackableEvents["StartPayPalAuthentication"] = "Start Paypal Authentication";
    TrackableEvents["InformationIClick"] = "Clicked-Informational-I-Checkout";
    TrackableEvents["ClickedGamificationBar"] = "Clicked-Gamification-Bar";
    TrackableEvents["ClickedBrowseBanner"] = "Clicked-Browse-Banner";
    TrackableEvents["ClickedNotification"] = "Clicked Notification";
    TrackableEvents["OpenNotifications"] = "Open Notifications";
    TrackableEvents["ViewedLiveSession"] = "Viewed-LiveSession";
    TrackableEvents["ClickedLiveSessionRegister"] = "Clicked-LiveSession-Register";
    TrackableEvents["ClickedLiveSessionJoin"] = "Clicked-LiveSession-Join";
    TrackableEvents["ClickedLiveSessionFollow"] = "Clicked-LiveSession-Follow";
    TrackableEvents["ClickedLiveSessionUnfollow"] = "Clicked-LiveSession-Unfollow";
    TrackableEvents["ClickedLiveSessionFAQ"] = "Clicked-LiveSession-FAQ";
    TrackableEvents["ClickedAnnouncementBanner"] = "Clicked-Banner-DefaultFreeTrial";
    TrackableEvents["ViewedProject"] = "Viewed.Project";
    TrackableEvents["AttemptedSkipOnboardingModal"] = "AttemptedSkip-OnboardingModal";
    TrackableEvents["DeselectedOnboardingSkill"] = "Deselected-Onboarding-Skill";
    TrackableEvents["SelectedOnboardingSkill"] = "Selected-Onboarding-Skill";
    TrackableEvents["SubmitOnboardingSkills"] = "Submitted-Onboarding-Skills";
    TrackableEvents["ClosedWelcomeRow"] = "Closed-WelcomeRow";
    TrackableEvents["ViewedOnboardingSkillSelection"] = "Viewed-Onboarding-SkillSelection";
    TrackableEvents["Changed Video Playback Speed"] = "Changed Video Playback Speed";
    TrackableEvents["Clicked Invite Gmail Contacts"] = "Clicked Invite Gmail Contacts";
    TrackableEvents["Clicked Share Button"] = "Clicked Share Button";
    TrackableEvents["Played Lesson Video"] = "Played Lesson Video";
    TrackableEvents["Clicked Mobile Open App Link"] = "Clicked Mobile Open App Link";
    TrackableEvents["Clicked Mobile Install App Link"] = "Clicked Mobile Install App Link";
    TrackableEvents["Open Notifications"] = "Open Notifications";
    TrackableEvents["Performed-Browse-ScrollMore"] = "Performed-Browse-ScrollMore";
    TrackableEvents["Viewed Learn Mode"] = "Viewed Learn Mode";
    TrackableEvents["Viewed Student Referral Form"] = "Viewed Student Referral Form";
    TrackableEvents["Search Performed"] = "Search Performed";
    TrackableEvents["Clicked-Banner-DefaultFreeTrial"] = "Clicked-Banner-DefaultFreeTrial";
    TrackableEvents["Clicked-Premium-Share-End-Card"] = "Clicked-Premium-Share-End-Card";
    TrackableEvents["Used Tag Suggester"] = "Used Tag Suggester";
    TrackableEvents["Followed User"] = "Followed User";
    TrackableEvents["Received-VideoPlaybackBlocked"] = "Received-VideoPlaybackBlocked";
    TrackableEvents["Selected-Subtitles"] = "Selected-Subtitles";
    TrackableEvents["Enable Captions"] = "Enable Captions";
    TrackableEvents["Disable Captions"] = "Disable Captions";
    TrackableEvents["Played-Video"] = "Played-Video";
    TrackableEvents["Paused-Video"] = "Paused-Video";
    TrackableEvents["Activated-PictureInPicture"] = "Activated-PictureInPicture";
    TrackableEvents["Deactivated-PictureInPicture"] = "Deactivated-PictureInPicture";
    TrackableEvents["Start Review"] = "Start Review";
    TrackableEvents["Submit Review"] = "Submit Review";
    TrackableEvents["Completed All Class Videos"] = "Completed All Class Videos";
    TrackableEvents["Clicked-Playlist-Lesson"] = "Clicked-Playlist-Lesson";
    TrackableEvents["Class Onboarding: Viewed Onboarding"] = "Class Onboarding: Viewed Onboarding";
    TrackableEvents["Class Onboarding: Completed"] = "Class Onboarding: Completed";
    TrackableEvents["Viewed Referral Popup"] = "Viewed Referral Popup";
    TrackableEvents["Clicked-Account-DeactivateButton"] = "Clicked-Account-DeactivateButton";
    TrackableEvents["Opened Extend Free Trial Popup"] = "Opened Extend Free Trial Popup";
    TrackableEvents["Clicked Extend Free Trial Button"] = "Clicked Extend Free Trial Button";
    TrackableEvents["Start Paypal Authentication"] = "Start Paypal Authentication";
    TrackableEvents["Viewed Live Session Referral Popup"] = "Viewed Live Session Referral Popup";
    TrackableEvents["Viewed Become Premium Enrollment Popup"] = "Viewed Become Premium Enrollment Popup";
    TrackableEvents["Accepted Two Year Plan Reminder"] = "Accepted Two Year Plan Reminder";
    TrackableEvents["Viewed Teacher Welcome Banner"] = "Viewed Teacher Welcome Banner";
    TrackableEvents["Clicked-Onboarding-UndoButton"] = "Clicked-Onboarding-UndoButton";
    TrackableEvents["Clicked-Onboarding-CloseButton"] = "Clicked-Onboarding-CloseButton";
    TrackableEvents["Start Cancellation"] = "Start Cancellation";
    TrackableEvents["Selected Plan On Membership Page"] = "Selected Plan On Membership Page";
    TrackableEvents["Viewed-Class-AboutTab"] = "Viewed-Class-AboutTab";
    TrackableEvents["Viewed-Class-ReviewsTab"] = "Viewed-Class-ReviewsTab";
    TrackableEvents["Viewed-Class-LessonsTab"] = "Viewed-Class-LessonsTab";
    TrackableEvents["Viewed-Class-ProjectsTab"] = "Viewed-Class-ProjectsTab";
    TrackableEvents["Viewed-Class-DiscussionsTab"] = "Viewed-Class-DiscussionsTab";
    TrackableEvents["Viewed-Class-TranscriptsTab"] = "Viewed-Class-TranscriptsTab";
    TrackableEvents["View Account Settings"] = "View Account Settings";
    TrackableEvents["Start Deactivation"] = "Start Deactivation";
    TrackableEvents["Viewed-TeamAdministration"] = "Viewed-TeamAdministration";
    TrackableEvents["Submitted Project Embed Url"] = "Submitted Project Embed Url";
    TrackableEvents["Submitted Video Embed Url"] = "Submitted Video Embed Url";
    TrackableEvents["Submitted Other Embed Url"] = "Submitted Other Embed Url";
    TrackableEvents["Submitted Link Embed Url"] = "Submitted Link Embed Url";
    TrackableEvents["Submitted Class Embed Url"] = "Submitted Class Embed Url";
    TrackableEvents["Directly Viewed Locked Video"] = "Directly Viewed Locked Video";
    TrackableEvents["Opened Add To Calendar Popover"] = "Opened Add To Calendar Popover";
    TrackableEvents["Added Class To Google Calendar"] = "Added Class To Google Calendar";
    TrackableEvents["Added Class To Yahoo Calendar"] = "Added Class To Yahoo Calendar";
    TrackableEvents["Added Class To List"] = "Added Class To List";
    TrackableEvents["Added Class To Outlook Calendar"] = "Added Class To Outlook Calendar";
    TrackableEvents["Added Class To Apple Calendar"] = "Added Class To Apple Calendar";
    TrackableEvents["Manage Membership"] = "Manage Membership";
    TrackableEvents["Viewed Workshop Classes Section"] = "Viewed Workshop Classes Section";
    TrackableEvents["Viewed Workshop Projects Section"] = "Viewed Workshop Projects Section";
    TrackableEvents["Viewed Workshop Discussionshow Section"] = "Viewed Workshop Discussionshow Section";
    TrackableEvents["Viewed Workshop Show Section"] = "Viewed Workshop Show Section";
    TrackableEvents["Viewed Workshop Details Section"] = "Viewed Workshop Details Section";
    TrackableEvents["Viewed Workshop Discussions Section"] = "Viewed Workshop Discussions Section";
})(TrackableEvents || (TrackableEvents = {}));
//# sourceMappingURL=events.js.map